import { useTranslation } from "react-i18next"

import { baseColumnDef } from "@/nzds/data-grid"
import { getDisplayValue } from "@/utils/value"

import type { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro"

interface UseUtilityProviderColumnOptions {
  field?: string
  filterable?: boolean
}

export const useUtilityProviderColumn = <TRow extends GridValidRowModel>(
  options: UseUtilityProviderColumnOptions = {}
): GridColDef<TRow> => {
  const { t } = useTranslation("common")
  const field = options.field ?? "provider_name"
  const filterable = options.filterable ?? false

  return {
    ...baseColumnDef,
    field,
    filterable,
    flex: 1,
    headerName: t("fields.utilityProvider.title"),
    maxWidth: 360,
    minWidth: 160,
    sortable: false,
    valueFormatter: (value: string | null | undefined) =>
      getDisplayValue(value),
  }
}
